import { selectItemById } from '../query/selectItemById';
import { mutator } from 'satcheljs';
import {
    updateItem,
    upsertItemsForDescriptor,
    addItem,
    deleteItem,
    replaceItems,
} from '../actions/internalActions';
import { getStore } from '../store/store';
import type { CacheItem } from '../store/schema/CacheItem';

mutator(updateItem, actionMessage => {
    const { key, itemUpdates, itemId } = actionMessage;
    const store = getStore(key);
    const itemFound = selectItemById(store, itemId);

    if (!itemFound) {
        return;
    }
    update(key, itemFound, itemUpdates);
});

mutator(replaceItems, actionMessage => {
    const { key, items } = actionMessage;
    replace(key, items);
});

mutator(upsertItemsForDescriptor, actionMessage => {
    const { key, items } = actionMessage;
    add(key, items);
});

mutator(addItem, actionMessage => {
    const { key, item } = actionMessage;
    add(key, [item]);
});

mutator(deleteItem, actionMessage => {
    const { key, itemId } = actionMessage;
    remove(key, [itemId]);
});

function remove(key: string, itemIds: string[]) {
    itemIds.forEach(itemId => {
        getStore(key).items.delete(itemId);
    });
}

function add<T extends CacheItem>(key: string, items: T[]) {
    items.forEach(item => {
        getStore(key).items.set(item.Id, item);
    });
}

function replace<T extends CacheItem>(key: string, items: T[]) {
    getStore(key).items.clear();
    add(key, items);
}

function update<T extends CacheItem>(key: string, originalItem: T, updates: Partial<T>) {
    // Create a task that combines the old properties with the new updates.
    const itemToSave = { ...originalItem, ...updates };
    add(key, [itemToSave]);
}
